// This is DateFilterButtonsYear.js

import React from 'react';
import './DateFilterButtons.css'; // reuse the same styles
import { PERIOD_CONFIG, DATE_FILTER_YEAR_PERIOD_KEYS } from './DateFilterButtons';

const DateFilterButtonsYear = ({ selectedPeriod, onPeriodChange }) => {
  return (
    <div className="date-filter-buttons-container">
      <div className="date-filter-buttons">
        {DATE_FILTER_YEAR_PERIOD_KEYS.map((periodKey) => (
          <button
            key={periodKey}
            className={`date-filter-btn ${selectedPeriod === periodKey ? 'active' : ''}`}
            onClick={() => onPeriodChange(periodKey)}
          >
            {PERIOD_CONFIG[periodKey].label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateFilterButtonsYear;
